// Read-aloud with the device's own voices (Web Speech API). Text is spoken
// sentence by sentence because some engines stop long utterances midway.
let queue = [];
let onDone = null;
let active = false;

export function speechSupported() {
  return typeof window !== 'undefined' && 'speechSynthesis' in window && 'SpeechSynthesisUtterance' in window;
}

function voice() {
  const voices = speechSynthesis.getVoices().filter((v) => /^en(-|_|$)/i.test(v.lang));
  const score = (v) => (/(natural|premium|enhanced|neural)/i.test(v.name) ? 4 : 0)
    + (/^en-(GB|IN|US|AU)/i.test(v.lang) ? 1 : 0)
    + (/(samantha|daniel|serena|google uk english|google us english|arthur|martha)/i.test(v.name) ? 2 : 0)
    + (v.localService ? 1 : 0);
  return voices.sort((a, b) => score(b) - score(a))[0] || null;
}

function next() {
  if (!queue.length) {
    active = false;
    const fn = onDone;
    onDone = null;
    if (fn) fn();
    return;
  }
  const u = new SpeechSynthesisUtterance(queue.shift());
  const v = voice();
  if (v) u.voice = v;
  u.lang = v ? v.lang : 'en-GB';
  u.rate = 0.96;
  u.onend = next;
  u.onerror = () => stop();
  speechSynthesis.speak(u);
}

export function speak(text, done) {
  stop();
  queue = String(text).match(/[^.!?;:]+[.!?;:]*\s*/g) || [String(text)];
  queue = queue.map((s) => s.trim()).filter(Boolean);
  onDone = done || null;
  active = true;
  next();
}

export function stop() {
  const fn = onDone;
  queue = [];
  onDone = null;
  active = false;
  if (speechSupported()) speechSynthesis.cancel();
  if (fn) fn();
}

export function speaking() {
  return active;
}
